import React, { useEffect, useRef, useState } from "react";
import { getSharePopularity } from "../service/inspire-service";
import LoadingSpinner from "../common/loading";
import { PremadesList } from "./premade-gallery-view";
import { useWebSocket } from "../ws/websocket";
import { useHistory } from "react-router-dom";

const PAGE_SIZE = 20;

const SharePopularityView = () => {
  const [premades, setPremades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [nextToken, setNextToken] = useState("");
  const { sendAndWaitWs } = useWebSocket();
  const observerRef = useRef(null);
  const history = useHistory();

  useEffect(() => {
    fetchPopularityList(true);
  }, []);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "100px",
      threshold: 0,
    };

    if (observerRef.current) {
      observerRef.current.disconnect();
    }

    const observer = new window.IntersectionObserver((entries) => {
      const target = entries[0];
      if (target.isIntersecting && !loading && hasMore) {
        fetchPopularityList(false);
      }
    }, options);

    const observerTarget = document.querySelector(".observer-target");
    if (observerTarget) {
      observer.observe(observerTarget);
    }

    observerRef.current = observer;

    return () => {
      if (observer) observer.disconnect();
    };
    // eslint-disable-next-line
  }, [loading, hasMore]);

  const fetchPopularityList = async (isReset = false) => {
    if (loading || (!hasMore && !isReset)) return;
    setLoading(true);
    try {
      const resp = await getSharePopularity(
        sendAndWaitWs,
        PAGE_SIZE,
        "userShared",
        isReset ? "" : encodeURIComponent(nextToken)
      );
      if (resp && !resp.error) {
        const newPremades = resp.sharedEntries || [];
        setPremades(isReset ? newPremades : [...premades, ...newPremades]);
        setHasMore(resp.pagination?.hasMore || false);
        setNextToken(resp.pagination?.nextToken || "");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAdopt = (data) => {
    history.push(`/automation/overview?shareId=${data.sharedId}`);
  };

  return (
    <div style={{ padding: "16px" }}>
      <PremadesList premades={premades} onAdopt={handleAdopt} />
      <div
        className="observer-target"
        style={{
          height: "20px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {loading && <LoadingSpinner />}
      </div>
      {!loading && !hasMore && premades.length > 0 && (
        <div style={{ textAlign: "center", color: "#888", padding: 16 }}>
          No more data
        </div>
      )}
    </div>
  );
};

export default SharePopularityView;
